<template>

   <div class="container">
      {{ title }}
   </div>

</template>

<script>

export default {
  name: 'head-slots',
  props:{
    title:{default:"no title prop set."},
  },
  data:function(){
    return {
    }
  },
  methods:{
  },
  mounted:function(){
    
  },
  components:{
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  /* add new styling */
  border-top:1px solid #707070;
  background-color:#EEEEEE;
  color:inherit;
  padding:5px 10px;
}

</style>
